/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable */
import React, { useRef, useState } from 'react';
import { makeStyles, useTheme, styled } from '@material-ui/core/styles';
import { Button, TextField, Typography } from '@material-ui/core';
import { Box, Grid } from '@mui/material';
import Image from 'next/image';
import Autocomplete from '@material-ui/lab/Autocomplete';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useRouter } from 'next/router';
import HeaderText from '../UI/Headers/HeaderText';
import mapStationData from '../../utils/MapStationData';

// Styles
const useStyles = makeStyles((theme) => ({
  map: {
    position: 'relative',
    marginLeft: '-100px',
    width: '1000px',
    height: '600px',
    [theme.breakpoints.down('md')]: {
      width: '800px',
      height: '480px',
      marginLeft: '-80px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '500px',
      height: '300px',
      marginLeft: '-50px',
    },
  },
  inputField: {
    backgroundColor: 'white',
    width: '100%',
  },
  locations: {
    scrollMarginTop: '60px',
  },
}));

const StyledLocationBox = styled(Box)(({ theme, location }) => ({
  top: location.centerTop * 0.5 + 60,
  left: location.centerLeft * 0.5 + 10,
  height: '15px',
  width: '15px',
  position: 'absolute',
  [theme.breakpoints.up('md')]: {
  '&:hover': {
    cursor: 'pointer',
    height: '30px',
    width: '30px',
    marginLeft: '-7.5px',
    marginTop: '-7.5px',
    },
  },
  [theme.breakpoints.down('md')]: {
    top: location.centerTop * 0.4 + 48,
    left: location.centerLeft * 0.4 + 8,
    height: '12px',
    width: '12px',
    '&:hover': {
      cursor: 'pointer',
      height: '24px',
      width: '24px',
      marginLeft: '-6px',
      marginTop: '-6px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    top: location.centerTop * 0.25 + 30,
    left: location.centerLeft * 0.25 + 5,
    height: '7.5px',
    width: '7.5px',
    '&:hover': {
      cursor: 'pointer',
      height: '15px',
      width: '15px',
      marginLeft: '-3.75px',
      marginTop: '-3.75px',
    },
  },
}));

const Locations = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const router = useRouter();
  const { data } = props;
  const airportAmount = data.locations.length;
  const [selectedlocation, setSelectedLocation] = useState(null);

  console.warn = () => {};

  const locationRed = useRef(null);
  const scrollToLocations = () => locationRed.current.scrollIntoView();

  return (
    <Box pt={{ xs: 6, md: 14 }} pb={{ xs: 2, md: 6 }} position="relative">
      <Grid container>
        <Grid item xs={12} lg={5} order={{ xs: 1, lg: 1 }} className={classes.sideBorder}>
          <Box mt={6} />
          <HeaderText text1="Our" text2="Locations" />
          <Typography variant="body1">
            Widerøe Ground Handling has coverage across all of Norway and offers
            its services at {airportAmount ? airportAmount : "-"} airports, from Oslo to Kirkenes.
            Don&apos;t hesitate to contact us with any questions or ground handling inquiries!
          </Typography>
          <Box mt={2} />
          <Autocomplete
            options={data.locations}
            onChange={(event, item) => {
              router.push(`location/${item.airportCode}`);
            }}
            getOptionLabel={(item) => `${item.airportName} (${item.airportCode})`}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Enter location name"
                variant="outlined"
                className={classes.inputField}
              />
            )}
          />
          <Box mt={6} display="flex" width="100%" alignItems="center" flexDirection="column">
            <Button
              variant="contained"
              style={{ fontWeight: 'bold', alignItems: 'center' }}
              size="large"
              color="primary"
              onClick={scrollToLocations}
            >
              All locations
            </Button>
            <KeyboardArrowDownIcon color="primary" />
          </Box>
        </Grid>
        <Grid item xs={12} lg={7} order={{ xs: 2, lg: 2 }} style={{ display: 'flex', justifyContent: 'center' }}>
          <Box position="relative">
            <Box className={classes.map}>
              <img src="/static/images/MapNew.svg" layout="fill" style={{position: "absolute", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%", objectFit: "contain"}} alt="Map" />
              {data.locations.map((item) => {
                const location = mapStationData(item.airportCode);
                return (
                  <>
                    <StyledLocationBox
                      location={location}
                      onMouseEnter={() => setSelectedLocation(item)}
                      onMouseLeave={() => setSelectedLocation(null)}
                      onClick={() => router.push(`location/${item.airportCode}`)}
                      key={item.airportCode + item.airportName}
                    >                      
                    {selectedlocation && selectedlocation.airportCode === item.airportCode ? 
                      <Typography variant="h6" key={item.airportCode} style={{marginLeft: 30, marginTop: 0, zIndex: 101, position: "absolute"}}>
                        {item.airportCode}
                      </Typography> : null}
                      <img src="/static/images/LocationPin.svg" layout="fill" objectFit="contain" style={{position: "absolute", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%", objectFit: "contain"}} alt="Map"/>
                    </StyledLocationBox>
                  </>
                );
              })}
            </Box>
          </Box>
        </Grid>
        <Grid
          container
          item
          xs={12}
          order={{ xs: 3, lg: 2 }}
          ref={locationRed}
          className={classes.locations}
          style={{
            [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
              backgroundColor: 'red',
            },
          }}
        >
          {data.locations.map((item, i) => (
            <Grid item xs={6} md={4} key={item.airportName}>
              <Button
                color="primary"
                key={item.airportName + i}
                onClick={() => router.push(`location/${item.airportCode}`)}
              >
                {`${item.airportName} (${item.airportCode})`}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Locations;
